import { useEffect, useState } from 'react';
import { GridApi, IRowNode, SelectionChangedEvent } from 'ag-grid-community';

import { useDataGridApi } from '../data-grid.provider';

export function useSelectedRows<Row extends { id: number }>() {
  const getGridApi = useDataGridApi();
  const [selectedRows, setSelectedRows] = useState<Row[]>([]);

  /*
    For correct selection, need to use `getRowId` prop for <DataGrid/>
  */
  async function selectRows(rows: Row[]) {
    const gridApi = await getGridApi();
    const foundNodes: IRowNode<any>[] = [];

    gridApi.forEachNode((node) => {
      const foundNode = rows.find((row) => row.id.toString() === node.id);
      if (foundNode) foundNodes.push(node);
    });

    gridApi.setNodesSelected({
      nodes: foundNodes,
      newValue: true,
      source: 'api',
    });
  }

  useEffect(() => {
    let gridApi: GridApi | null = null;
    const subscribeFn = (event: SelectionChangedEvent) => {
      const selectedRows = event.api.getSelectedRows();
      setSelectedRows(selectedRows);
    };
    async function subscribeToSelectRows() {
      gridApi = await getGridApi();

      gridApi.addEventListener('selectionChanged', subscribeFn);
    }

    subscribeToSelectRows();

    return () => {
      gridApi?.removeEventListener('selectionChanged', subscribeFn);
    };
  }, [getGridApi]);

  return { selectedRows, selectRows };
}
